import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import LoadingScreen from '../LoadingScreen';

export default function ProtectedPortal({ client, mePath, loginPath, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    setReady(false);

    async function verify() {
      try {
        await client.get(mePath);
        if (active) {
          setReady(true);
        }
      } catch (error) {
        if (!active) {
          return;
        }
        const redirect = encodeURIComponent(location.pathname + location.search);
        navigate(`${loginPath}?redirect=${redirect}`, { replace: true });
      }
    }

    verify();

    return () => {
      active = false;
    };
  }, [client, location.pathname, location.search, loginPath, mePath, navigate]);

  if (!ready) {
    return <LoadingScreen />;
  }

  return children || <Outlet />;
}
